module.exports = __webpack_public_path__ + "img/logo_opacity.aa0978e2.png";